import React from "react";
import "./commonBanner.scss";
import { Link } from "react-router-dom";
import { homeURL } from "../../helpers/paths";

const CommonBanner = ({ text, link, link1, text1, title }) => {
  return (
    <>
      <section className="common_bann_sec1" data-aos="fade">
        <div className="my_container">
          <div className="breadcrumb">
            <Link to={homeURL} className="bread_link">
              Home
            </Link>
            {link && (
              <>
                {text1 ? (
                  <Link to={link} className={`bread_link space`}>
                    {" | " + text}
                  </Link>
                ) : (
                  <div className={`bread_link space`}>{" | " + text}</div>
                )}
              </>
            )}
            {text1 && <div className="bread_link">{" | " + text1}</div>}
          </div>
          <div className="content_wrapper">
            <h1 className="banner_title">{title}</h1>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonBanner;
